import { ObservableArray, View } from "binder"
import { ProductSearchViewModel, item } from "./productSearch-viewModel"
import { ProductSearchableSelectorViewModel } from "./productSearchableSelector/productSearchableSelector-viewModel";

export class ProductSearchView extends View<ProductSearchViewModel>{
    GetViewUniqueId(): string {
        return "V-439C8F7C-6D02-4B8E-8317-A9FD1B01F418"
    }
    loadHtml(): string {
        let element = require('./productSearch.html').default;
        let style = require('./productSearch.less');
        return element;
    }
    constructor() {
       super();
    }
    public set searcher(v: ProductSearchableSelectorViewModel) { this._searcher = v; } public get searcher(): ProductSearchableSelectorViewModel { return this._searcher;} private _searcher: ProductSearchableSelectorViewModel;
    public set items(v: ObservableArray<item>) { this._items = v; } public get items(): ObservableArray<item> { return this._items;} private _items: ObservableArray<item>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    async refresh() {
        this.dataContext.refresh();
    }

}
